export function isiOS() {
  return (
    // any apple-based device
    typeof navigator !== 'undefined' &&
    (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document))
  );
}
